import React from 'react';
import { GridColDef } from '@mui/x-data-grid-pro';
import { Link as MuiLink } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { XGridDefaultColumn } from '@AMIEWEB/Common/XGrid/cells/XGridDefaults';
import { XGridOverflowCell } from '@AMIEWEB/Common/XGrid/cells/XGridOverflowCell';
import { orderPayPackageColumns } from '@AMIEWEB/Order/OrderDetails/PayPackages/OrderPayPackages/utils';
import { missingField } from 'app/constants';

const OrderPayPackageDefaultCell = {
  ...XGridDefaultColumn,
  flex: 0,
};

const buildPathFromRow = (path: string, fieldList: string[], row: any) => {
  let linkBuild = path;
  fieldList?.forEach((id, index) => {
    linkBuild = linkBuild.replace(`{${index}}`, `${row?.[id]}`);
  });
  return linkBuild;
};

const XGridNewTabLinkCell =
  (path: string, fieldList: string[] = []) =>
  (params: any) => {
    if (params?.value === missingField) return React.createElement('span', null, params?.value);
    const to = buildPathFromRow(path, fieldList, params?.row);
    return React.createElement(
      MuiLink,
      {
        component: RouterLink as any,
        to,
        target: '_blank',
        rel: 'noopener noreferrer',
        underline: 'hover',
      } as any,
      params?.value ?? missingField,
    );
  };

/**
 * Facility Order Pay Packages columns - adds Order ID column (link to Order Profile Pay Packages tab)
 * and reuses Order Pay Package columns with all cells read-only (no editing).
 */
export const facilityOrderPayPackageColumns = (t): GridColDef[] => [
  {
    ...OrderPayPackageDefaultCell,
    field: 'orderId',
    headerName: t('order.payPackagesTab.orderPayPackages.grid.column.orderId'),
    width: 100,
    renderCell: XGridOverflowCell(XGridNewTabLinkCell('/order/{0}?tab=6', ['orderId']))(
      XGridNewTabLinkCell('/order/{0}?tab=6', ['orderId']),
    ),
  },
  ...orderPayPackageColumns(t).map(col => ({
    ...col,
    editable: false,
  })),
];

export const facilityOrderPayPackagesColumnVisibility = {
  orderId: true,
  skillset: true,
  shift: true,
  minimumRequiredHours: true,
  publishingStatus: true,
  originalTargetMargin: true,
  currentTargetMargin: true,
  weeklyGrossPay: true,
  minimumWeeklyGrossPay: true,
  maximumWeeklyGrossPay: true,
  billRate: true,
  vms: true,
  other: true,
  payRate: true,
  lodgingPerDiem: true,
  mealPerDiem: true,
  orientationHours: true,
  updatedDateAt: false,
  updatedByName: false,
};
